import { Box, Layout, Cell } from '@wix/design-system';
import React, { useEffect } from 'react';
import s from '../styles/page.scss';
import { useMetasiteError } from '../context/errors';
import { useBiLogger } from '../hooks/useBiLogger/useBiLogger';
import { GeneralError } from '../components/GeneralError/GeneralError';
import { SetupMobile as SetupMobileRoot } from '../features/setupMobile/SetupMobile';
import { useLocalStorageSync } from '../hooks/useLocalStorageSync';
import { DsBuilderMethod } from '../types';

type SetupMobilePageProps = {};

export const SetupMobile: React.FC<SetupMobilePageProps> = () => {
  const metasiteError = useMetasiteError();

  // Use unified localStorage sync for category
  useLocalStorageSync({
    syncKeys: ['selectedCategory'],
  });

  const biLogger = useBiLogger();

  useEffect(() => {
    biLogger.pageView(DsBuilderMethod[DsBuilderMethod.SITE_PREVIEW]);
  }, []);

  if (metasiteError) {
    return <GeneralError />;
  }

  return (
    <>
      <Layout gap="32px">
        <Cell span={12}>
          <Box className={s.sectorBoxWrapper}>
            <SetupMobileRoot />
          </Box>
        </Cell>
      </Layout>
    </>
  );
};
